// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

import { version } from './version';

export const environment = {
  production: false,
  appVersionAddon: '-staging',
  webappName: 'Straatbeeld Online (staging)',
  api_endpoint: 'https://api.sd-staging.nl/',
  pusher: {
    broadcaster: 'pusher',
    key: 'fd4c5bb275e8ae76f1b4',
    cluster: 'eu',
    forceTLS: true,
  },
  sentry: {
    dsn: 'https://146eebc8437d9431671c83ed040b7088@o4507735602298880.ingest.de.sentry.io/4508635695284304',
    environment: 'staging',
    version: version + '-staging',
  }
};
